import { StyleSheet as PDFStyleSheet } from '@react-pdf/renderer'

const styles = PDFStyleSheet.create({
  mainDiv: {
    width: '100%',
    paddingLeft: '5%',
    paddingRight: '5%'
  },
  content: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap'
  },
  subject: {
    width: '100%',
    marginBottom: 10
  },
  subjectTitle: {
    fontSize: 8,
    color: 'black',
    marginRight: 2
  },
  subjectValue: {
    fontWeight: 'bold',
    fontSize: 8,
    color: 'black'
  },
  subjectValueRed: {
    marginTop: 2,
    fontSize: 8,
    color: 'red'
  },
  phoneNumberContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 5
  },
  hotelName: {
    width: '75%'
  },
  hotelNumber: {
    width: '25%',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  rowDirection: {
    display: 'flex',
    flexDirection: 'row',
    width: '60%'
  },
  rowDirection3: {
    display: 'flex',
    flexDirection: 'row',
    width: '40%'
  },
  rowDirection2: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%'
  }
})
export default styles
